export const NODE_RECAPTCHA_SITE_KEY_NAME = 'NODE_RECAPTCHA_SITE_KEY';
export const NODE_RECAPTCHA_SITE_KEY_V3_NAME = 'NODE_RECAPTCHA_SITE_KEY_V3';
